"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _reactTransitionGroup = require("react-transition-group");

var _themeUi = require("theme-ui");

var _Obfuscator = _interopRequireDefault(require("../Obfuscator/Obfuscator"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Dimmer = function Dimmer(_ref) {
  var visible = _ref.visible,
      onClickOutside = _ref.onClickOutside,
      children = _ref.children;
  var dialogRoot = (0, _react.useRef)(document.createElement('div'));
  (0, _react.useEffect)(function () {
    var element = dialogRoot.current;
    document.body.appendChild(element);
    return function () {
      document.body.removeChild(element);
    };
  }, []);
  var transitionStyles = {
    dialog: {
      entering: {
        transition: function transition(theme) {
          return "transform 300ms " + theme.easing.slowToQuick;
        },
        transform: function transform(theme) {
          return "translateY(-" + theme.space[6] + "px)";
        }
      },
      entered: {
        transform: 'translateY(0px)',
        transition: function transition(theme) {
          return "transform 300ms " + theme.easing.quickToSlow;
        }
      },
      exiting: {
        transition: function transition(theme) {
          return "transform 300ms " + theme.easing.slowToQuick;
        },
        transform: function transform(theme) {
          return "translateY(-" + theme.space[6] + "px)";
        }
      }
    },
    obfuscator: {
      entering: {
        opacity: 0,
        transition: function transition(theme) {
          return "opacity 300ms " + theme.easing.slowToQuick;
        }
      },
      entered: {
        opacity: 1,
        transition: function transition(theme) {
          return "opacity 300ms " + theme.easing.quickToSlow;
        }
      },
      exiting: {
        opacity: 0,
        transition: function transition(theme) {
          return "opacity 300ms " + theme.easing.slowToQuick;
        }
      }
    }
  };
  return (0, _reactDom.createPortal)((0, _themeUi.jsx)(_reactTransitionGroup.Transition, {
    "in": visible,
    timeout: {
      enter: 0,
      exit: 400
    },
    appear: true,
    mountOnEnter: true,
    unmountOnExit: true
  }, function (state) {
    return (0, _themeUi.jsx)(_Obfuscator["default"], {
      sx: _extends({
        position: 'fixed',
        zIndex: 9,
        opacity: 0,
        transition: function transition(theme) {
          return "opacity 300ms " + theme.easing.slowToQuick;
        }
      }, transitionStyles.obfuscator[state]),
      onClick: onClickOutside
    }, (0, _themeUi.jsx)("div", {
      sx: _extends({
        boxSizing: 'border-box',
        display: 'flex',
        height: '100%',
        width: '100%',
        justifyContent: 'center',
        position: 'relative',
        alignItems: ['stretch', 'flex-start'],
        transition: function transition(theme) {
          return "transform 300ms " + theme.easing.slowToQuick;
        },
        transform: function transform(theme) {
          return "translateY(-" + theme.space[6] + "px)";
        }
      }, transitionStyles.dialog[state], {
        '.Dialog': {
          mt: [6, 7],
          mx: 3
        },
        '.Modal': {
          mt: function mt(theme) {
            return [0, theme.sizes[8]];
          },
          mx: [0, 3]
        }
      })
    }, (0, _themeUi.jsx)(_themeUi.Flex, {
      sx: {
        mb: [0, 7],
        justifyContent: 'center',
        alignItems: 'flex-start',
        width: '100%'
      }
    }, _react["default"].Children.only(_react["default"].cloneElement(children, {
      freeze: !visible,
      onClick: function onClick(event) {
        return event.stopPropagation();
      }
    })))));
  }), dialogRoot.current);
};

Dimmer.propTypes = {
  visible: _propTypes["default"].bool.isRequired,
  onClickOutside: _propTypes["default"].func,
  children: _propTypes["default"].node.isRequired
};
var _default = Dimmer;
exports["default"] = _default;